import React from 'react'

import LoadIndicator from 'devextreme-react/load-indicator'

import './spinner.scss'

export const Spinner = () => {
    return (
        <div className='spinner-panel' data-testid="spinner">
            <div className='spinner-indicator'>
                <LoadIndicator />
            </div>
        </div>
    )
}
